import { render, staticRenderFns } from "./settings-company-stores.vue?vue&type=template&id=104d2d3a&"
import script from "./settings-company-stores.ts?vue&type=script&lang=ts&"
export * from "./settings-company-stores.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports